export default __webpack_public_path__ + "static/media/taskfor_you_arrow_icon.def08fcd.svg";